 <app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="marcheFournitures.locationVente" 
 
[label]="''"
[type]="'radio'" [rule]="'pattern_29'"
[name]="radioButtonCtrlName"
[value]="radioButtonValue"
[name]="getUid()+'_SepAtt_locationVente'"
[radios]="[
    {
        value: achat,
        label: step2.getachat
    },
    {
        value: creditBail,
        label: step2.getcreditbail
    },
    {
        value: location,
        label: step2.getlocation
    },
    {
        value: locationVente,
        label: step2.getlocationvente
    }
]">
</app-form-input>

<!-- 
<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="marcheFournitures.achat" 
 
[label]="'achat'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_achat'">
</app-form-input>


<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="marcheFournitures.location" 
 
[label]="'location'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_location'">
</app-form-input>


<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="marcheFournitures.creditBail" 
 
[label]="'creditBail'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_creditBail'">
</app-form-input> -->
